import { useState, useEffect } from 'react';
import Axios from 'axios';
import Constants from '../config/constants';

/**
 * Hook สำหรับดึงรายชื่อ staff จาก API
 * คืนค่า:
 *   staff       - array [{key, text, value}]  สำหรับ dropdown (ไม่มี "ทั้งหมด")
 *   staffSearch - array [{key, text, value}]  มี option "ทั้งหมด" เป็นตัวแรก
 *   loading     - boolean
 */
const useStaff = () => {
    const [staff, setStaff] = useState([]);
    const [staffSearch, setStaffSearch] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStaff = async () => {
            try {
                const result = await Axios.get(
                    'http://' + Constants.url + ':' + Constants.port + '/v1/snr/staff',
                    {
                        headers: {
                            Authorization: Constants.headerAuthorization,
                            'Content-Type': 'application/json'
                        }
                    }
                );
                const list = result.data.data || [];
                setStaff(list);
                setStaffSearch([{ key: 99, text: 'ทั้งหมด', value: 99 }, ...list]);
            } catch (e) {
                console.error('Failed to load staff list:', e);
            } finally {
                setLoading(false);
            }
        };
        fetchStaff();
    }, []);

    return { staff, staffSearch, loading };
};

export default useStaff;
